import { produce } from 'immer'
import baseReducer from '@utilities/base-reducer'
import * as Actions from './address-step-action'

const initialState = {
  address: {
    zipCode: '',
    street: '',
    number: '',
    addressComplement: '',
    district: '',
    city: '',
    uf: '',
  },
}

const onboardingReducer = baseReducer(initialState, {
  [Actions.SET_ADDRESS_FIELD](state, { payload: { name, value } }) {
    return produce(state, draftState => {
      draftState.address = { ...state.address, [name]: value }
    })
  },
  [Actions.REQUEST_GET_ADDRESS_FINISHED](state, action) {
    return produce(state, draftState => {
      draftState.address = { ...state.address, ...action.payload }
    })
  },
})

export default onboardingReducer
